import { render } from "./BtnCComponent.vue?vue&type=template&id=22bf8cda&scoped=true"
import script from "./BtnCComponent.vue?vue&type=script&lang=js"
export * from "./BtnCComponent.vue?vue&type=script&lang=js"

import "./BtnCComponent.vue?vue&type=style&index=0&id=22bf8cda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bf8cda"]])

export default __exports__